import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  DeleteContactFromGroup_Url,
  GetGroup_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import RemoveContactButton from "../buttons/RemoveContactButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
class GroupContactsDialog extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;

  constructor(props) {
    super(props);
    this.state = {
      groupName: "",
      smsGroup: null,
      initialPage: 0,
      pageSize: 20,
      smsContactList: [],
      open: false,
      isRemoveContact: true,
      optinContact: false,
      pandingContact: false,
      onChange: props.onChange,
    };
    this.debouncedSearch = _.debounce(this.showGroupContactList, 800);
  }

  showGroupContactList(group, pageNo, pageSize) {
    const postObject = {
      header: this.header,
      smsGroup: {
        id: group?.id,
      },
      eventId: this.businessDomainId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
      },
    };
    FetchServerData.callPostService(GetGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsGroup = output.data.smsGroup;
          let page = output.data.page;
          let contactList = output.data?.smsGroup?.contactList;
          let isPaging = false;
          if (contactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < contactList?.length; i++) {
            const element = contactList[i];
            contactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element?.mobile
            );
          }
          this.setState({
            render: true,
            open: true,
            optinContact: false,
            pandingContact: false,
            isPaging: isPaging,
            smsGroup: smsGroup,
            smsContactList: contactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            isRemoveContact: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  showAllPendingContactList(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
      },
    };
    FetchServerData.callPostService(
      "/smscontactms/getPendingContactList",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let contactList = output.data.smsContactList;
          let page = output.data.page;
          let isPaging = false;
          if (contactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < contactList?.length; i++) {
            const element = contactList[i];
            contactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element?.mobile
            );
          }
          this.setState({
            render: true,
            open: true,
            pandingContact: true,
            isPaging: isPaging,
            smsContactList: contactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            smsGroup: { name: "All Pending" },
            isRemoveContact: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  showAllOptinContactList(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
      },
    };
    FetchServerData.callPostService(
      "/smscontactms/getOptinContactList",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let contactList = output.data.smsContactList;
          let page = output.data.page;
          let isPaging = false;
          if (contactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < contactList?.length; i++) {
            const element = contactList[i];
            contactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element?.mobile
            );
          }
          this.setState({
            render: true,
            open: true,
            optinContact: true,
            isPaging: isPaging,
            smsContactList: contactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            smsGroup: { name: "All Optins" },
            isRemoveContact: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  deleteContactToGroup(data) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      smsGroupContact: {
        smsGroup: {
          id: this.state.smsGroup?.id,
        },
        smsContact: {
          id: data.contactId,
        },
      },
    };

    FetchServerData.callPostService(DeleteContactFromGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsGroup = output.data.smsGroup;
          this.state.onChange();
          this.showGroupContactList(
            smsGroup,
            this.state.pageNo,
            this.state.pageSize
          );
        } else {
        }
      })
      .catch((error) => { });
  }

  showActionButton(rowData) {
    return (
      <>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <span className="me-2" style={{ cursor: "pointer" }}>
            <RemoveContactButton
              domainObject={rowData.mobile}
              onClick={this.deleteContactToGroup.bind(this, rowData)}
              pageId="contactGroup"
            />
          </span>
        </div>
      </>
    );
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.smsGroup,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    if (this.state.optinContact) {
      this.showAllOptinContactList(currentPageIndex, pageSize);
    } else if (this.state.pandingContact) {
      this.showAllPendingContactList(currentPageIndex, pageSize);
    } else {
      this.showGroupContactList(
        this.state.smsGroup,
        currentPageIndex,
        pageSize
      );
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>
            {`Contact List: ${this.state.smsGroup?.name}`}
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="row justify-content-between pb-2">
                  <div className="d-flex col-12 col-lg-4 col-xl-4">
                    <div className="col-12 text-start totalResults">
                      <span>Total Results: {this.state.totalRecords}</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-8 col-xl-8">
                    <div className="col-12 text-end">
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.showGroupContactList.bind(
                                  this,
                                  this.state.smsGroup,
                                  this.state.pageNo,
                                  this.state.pageSize
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  this.setState({ searchText: "" }, () => {
                                    this.showGroupContactList(
                                      this.state.smsGroup,
                                      this.state.pageNo,
                                      this.state.pageSize
                                    );
                                  });
                                }}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText ? 1 : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive paginationTable MuiPaper-elevation2">
                  <table className="table text-start table-hover mb-0">
                    <thead className="dialogPaginationTableThead">
                      <tr>
                        <th scope="col fw-bold">Mobile Number</th>
                        <th scope="col fw-bold">First Name</th>
                        <th scope="col fw-bold">Last Name</th>
                        <th scope="col fw-bold">Email</th>
                        {this.state.isRemoveContact && (
                          <th scope="col fw-bold">Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.smsContactList?.map((rowData, index) => (
                        <tr key={index}>
                          <td style={{ width: "175px" }}>{rowData.mobile}</td>
                          <td style={{ width: "140px" }}>
                            {rowData.firstName}
                          </td>
                          <td style={{ width: "140px" }}>{rowData.lastName}</td>
                          <td style={{ width: "200px" }}>{rowData.email}</td>
                          {this.state.isRemoveContact && (
                            <td style={{ width: "120px" }}>
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                                key={rowData.id}
                              >
                                <span
                                  className="me-2"
                                  style={{ cursor: "pointer" }}
                                >
                                  <RemoveContactButton
                                    domainObject={rowData.mobile}
                                    onClick={this.deleteContactToGroup.bind(
                                      this,
                                      rowData
                                    )}
                                    pageId="contactGroup"
                                  />
                                </span>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > this.state.pageSize && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export default GroupContactsDialog;
